<template>
  <div>
    <StandardCard title="Kontaktpersoner">
      <template v-slot:dialogBtn>
        <v-list-item-icon v-if="isMainContactPerson">
          <v-tooltip v-if="someContactPersonsIsDeactivated" top>
            <template v-slot:activator="{ on }">
              <v-btn
                class="mr-2"
                v-on="on"
                @click.stop="showDeactivateContactPersons"
                fab
                small
              >
                <v-icon>mdi-account-reactivate</v-icon>
              </v-btn>
            </template>
            <span>Gjenopprett kontaktperson</span>
          </v-tooltip>

          <v-tooltip v-if="!$vuetify.breakpoint.mdAndUp" top>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" @click.stop="addContact" fab small>
                <v-icon>mdi-account-multiple-plus</v-icon>
              </v-btn>
            </template>
            <span>Opprett kontaktperson</span>
          </v-tooltip>
        </v-list-item-icon>
      </template>

      <template v-slot>
        <v-list
          class="pb-0 pt-0"
          v-for="(contactPerson, index) in contactPersons"
          :key="index"
          color="cardSurface"
          two-line
        >
          <template>
            <v-divider v-if="index !== 0"></v-divider>

            <v-list-item>
              <v-list-item-avatar>
                <v-img
                  :src="
                    contactpersonApi.getProfilePhoto(contactPerson.person.email)
                  "
                ></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title>
                  {{ contactPerson.person.fullName }}
                  <v-icon
                    v-if="
                      contactPerson.isMainContactPerson ||
                      contactPerson.isBTAdmin
                    "
                    small
                    right
                  >
                    mdi-card-account-details-star
                  </v-icon>
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ contactPerson.person.email }}
                </v-list-item-subtitle>
              </v-list-item-content>
              <div
                v-if="
                  isMainContactPerson &&
                  contactPerson.id !== profile.contact.mainContactPersonId
                "
              >
                <v-list-item-action
                  v-if="!$vuetify.breakpoint.mobile"
                  class="mr-0"
                >
                  <!-- <v-list-item-content class="justify-end"> -->
                  <v-tooltip
                    top
                    v-if="
                      !contactPerson.externalUserExists ||
                      !contactPersonInivationStatus(contactPerson)
                    "
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-1"
                        icon
                        dark
                        small
                        color="primary"
                        @click="openSendInviteDialog(contactPerson)"
                      >
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-email-arrow-right
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{
                      contactPersonInivationStatus(contactPerson) == null
                        ? "Send invitasjonsmail"
                        : "Send invitasjon på nytt"
                    }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-1"
                        icon
                        dark
                        small
                        color="primary"
                        @click.stop="editContactPerson(contactPerson)"
                      >
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-account-edit
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Endre</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mx-1"
                        icon
                        dark
                        small
                        color="primary"
                        @click="confirmDeactivate(contactPerson)"
                      >
                        <v-icon v-bind="attrs" v-on="on" dark>
                          mdi-cancel
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Deaktiver</span>
                  </v-tooltip>
                  <!-- </v-list-item-content> -->
                </v-list-item-action>

                <v-list-item-action
                  v-if="$vuetify.breakpoint.mobile"
                  class="mr-0"
                >
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon v-bind="attrs" v-on="on">
                        <v-icon>mdi-dots-vertical</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="openSendInviteDialog(contactPerson)">
                        <v-list-item-icon>
                          <v-icon>mdi-email-arrow-right</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>
                            Send invitasjonsmail
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="editContactPerson(contactPerson)">
                        <v-list-item-icon>
                          <v-icon>mdi-account-edit</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Endre</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item @click="confirmDeactivate(contactPerson)">
                        <v-list-item-icon>
                          <v-icon>mdi-cancel</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-title>Deaktiver</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-list-item-action>
              </div>
            </v-list-item>
          </template>
        </v-list>

        <div v-if="loading">
          <v-list
            class="pb-0 pt-0"
            v-for="index in 5"
            :key="index"
            color="cardSurface"
            two-line
          >
            <template>
              <v-divider v-if="index !== 0"></v-divider>
              <v-list-item>
                <v-list-item-avatar>
                  <v-skeleton-loader
                    class="mx-auto"
                    max-width="300"
                    type="avatar"
                  ></v-skeleton-loader>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    <v-skeleton-loader
                      max-width="100"
                      type="text"
                    ></v-skeleton-loader>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    <v-skeleton-loader
                      max-width="250"
                      type="text"
                    ></v-skeleton-loader>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <div>
                  <v-list-item-action class="mr-0">
                    <v-list-item-content class="justify-end">
                      <v-skeleton-loader
                        max-width="250"
                        type="button"
                      ></v-skeleton-loader>
                    </v-list-item-content>
                  </v-list-item-action>
                </div>
              </v-list-item>
            </template>
          </v-list>
        </div>
      </template>
    </StandardCard>

    <AddContactDialog
      v-if="profile"
      v-model="showAddContactDialog"
      :activeContactId="profile.contact.id"
      @addNewContact="addNewContact"
    />

    <ConfirmDialog
      v-model="showConfirmDeactivate"
      title="Bekreft"
      icon="mdi-account-cancel"
      text="Er du sikker på at du vil deaktivere kontaktperson? Alle gjenværende oppgaver vil bli flyttet til deg!"
      btnActionName="Bekreft"
      @action="deactivateContactPerson"
    />

    <ConfirmDialog
      v-model="showConfirmSendInvite"
      title="Bekreft"
      icon="mdi-account-cancel"
      :text="getConfirmDialogText()"
      btnActionName="Send"
      @action="sendInvite"
    />

    <DesctivateContactPersonTasksDialog
      v-model="showDeactivateList"
      :reglines="changedResponsibleData.regLines"
      :actions="changedResponsibleData.actions"
    />
    <EditContactPersonDialog
      v-model="showEditDialog"
      :contactperson="contactpersonEdit"
      @save="saveEditContactPerson"
    />
    <DeactivatedContactPersonsDialog
      v-model="showDeactivateContactPersonsList"
      :data="deactivatedContactPersons"
      @activateContactPerson="activateContactPerson"
    />
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import api from "@/api/api";
import { mapGetters, mapActions } from "vuex";
import { ContactPersonObject } from "@/types/userInterface";

import contactApi from "@/api/contactApi";
import contactpersonApi from "@/api/contactpersonApi";

import StandardCard from "@/components/shared/cards/StandardCard.vue";
import AddContactDialog from "@/components/company/children/AddContactDialog.vue";
import ConfirmDialog from "@/components/shared/dialog/ConfirmDialog.vue";
import DesctivateContactPersonTasksDialog from "@/components/company/children/DesctivateContactPersonTasksDialog.vue";
import EditContactPersonDialog from "@/components/company/children/EditContactPersonDialog.vue";
import DeactivatedContactPersonsDialog from "@/components/company/children/DeactivatedContactPersonsDialog.vue";
import notification from "@/helpers/notification";

interface deactivateObject {
  regLines: Array<any>;
  actions: Array<any>;
}

export default Vue.extend({
  name: "CompanyContacts",
  data() {
    return {
      loading: false,
      showAddContactDialog: false,
      showConfirmSendInvite: false,
      sendInviteTo: null as ContactPersonObject | null,
      showConfirmDeactivate: false,
      saveContactInfoDeactivate: null as ContactPersonObject | null,
      showDeactivateList: false,
      changedResponsibleData: {} as deactivateObject,
      contactPersons: [] as Array<ContactPersonObject>,
      showEditDialog: false,
      contactpersonEdit: null as ContactPersonObject | null,
      contactpersonApi,
      showDeactivateContactPersonsList: false,
      deactivatedContactPersons: [] as Array<ContactPersonObject>,
      confirmDialogText:
        "Er du sikker på at du vil opprette Bygg Trysilhus bruker og sende invitasjonsmail?",
    };
  },

  mounted() {
    this.loading = true;
    contactApi.getContactpersons(this.profile.contact.id).then((x) => {
      this.contactPersons = x.contactPersons;
      this.contactPersons.forEach((x) => {
        if (x.id === this.profile?.contact.mainContactPersonId) {
          x.isMainContactPerson = true;
        }
      });

      this.deactivatedContactPersons = x.deactivatedContactPersons;
      this.loading = false;
    });
  },
  methods: {
    ...mapActions({
      updateProfile: "shared/updateProfile",
    }),
    addContact() {
      this.showAddContactDialog = true;
    },
    async addNewContact(contactPerson) {
      await api.addContactPerson(contactPerson).then((response) => {
        this.updateProfile(response.contactPerson);
        this.contactPersons = response.contactPersons;
        this.deactivatedContactPersons = response.deactivatedContactPersons;
        this.showAddContactDialog = false;
        notification.success(
          "Ny kontaktperson ble lagt til og invitasjonen e-post sendt!"
        );
      });
    },
    async sendInvite() {
      if (this.sendInviteTo) {
        await api.createContactPerson(this.sendInviteTo?.person).then(() => {
          (this as any).sendInviteTo.externalUserExists = true;
          this.showConfirmSendInvite = false;
        });
      }
    },
    openSendInviteDialog(contactPerson: ContactPersonObject) {
      this.sendInviteTo = contactPerson;
      this.showConfirmSendInvite = true;
      this.confirmDialogText = !contactPerson?.invitationAccepted
        ? "Er du sikker på at du vil sende Bygg Trysilhus invitasjonsmail på nytt?"
        : "Er du sikker på at du vil opprette Bygg Trysilhus bruker og sende invitasjonsmail?";
    },
    confirmDeactivate(contactPerson: ContactPersonObject) {
      this.saveContactInfoDeactivate = contactPerson;
      this.showConfirmDeactivate = true;
    },
    async deactivateContactPerson() {
      if (this.saveContactInfoDeactivate) {
        await contactApi
          .deactivateContactPerson(
            this.profile.contact.id,
            this.saveContactInfoDeactivate.id
          )
          .then((x) => {
            this.contactPersons = x.contactPersons;
            this.deactivatedContactPersons = x.deactivatedContactPersons;
            this.showConfirmDeactivate = false;

            this.changedResponsibleData.regLines = x.regLines;
            this.changedResponsibleData.actions = x.actions;

            var hasValue = Object.values(this.changedResponsibleData).some(
              (x) => {
                return x.length > 0;
              }
            );
            //If somthing is changed responsible. Then show dialog with list
            if (hasValue) {
              this.showDeactivateList = true;
            }
          })
          .catch(() => {
            this.showConfirmDeactivate = false;
          });
      }
    },
    editContactPerson(contactPerson: ContactPersonObject) {
      this.contactpersonEdit = contactPerson;
      this.showEditDialog = true;
    },
    saveEditContactPerson(contactPerson) {
      api.updateContactPersonContact(contactPerson).then((x) => {
        this.contactPersons = x.contactPersons;
        this.showEditDialog = false;
      });
    },
    showDeactivateContactPersons() {
      contactApi
        .getDeactivatedContactPersons(this.profile.contact.id)
        .then((x) => {
          this.deactivatedContactPersons = x;
          this.showDeactivateContactPersonsList = true;
        });
    },
    async activateContactPerson(contactPerson) {
      await contactApi
        .activateContactPerson(this.profile.contact.id, contactPerson.id)
        .then((x) => {
          notification.success(
            `Kontkaktperson "${contactPerson.person.fullName}" er aktivert!`
          );
          this.deactivatedContactPersons = x.deactivatedContactPersons;
          this.contactPersons = x.contactPersons;
          if (x.deactivatedContactPersons.length === 0) {
            this.showDeactivateContactPersonsList = false;
          }
        });
    },
    contactPersonInivationStatus(contactPerson) {
      return contactPerson?.invitationAccepted;
    },
    getConfirmDialogText() {
      return this.confirmDialogText;
    },
  },
  computed: {
    ...mapGetters({
      profile: "shared/profile",
      isMainContactPerson: "shared/isMainContactPerson",
    }),
    someContactPersonsIsDeactivated() {
      if (this.deactivatedContactPersons.length > 0) {
        return true;
      }
      return false;
    },
  },

  components: {
    StandardCard,
    AddContactDialog,
    ConfirmDialog,
    DesctivateContactPersonTasksDialog,
    EditContactPersonDialog,
    DeactivatedContactPersonsDialog,
  },
});
</script>
